<template>
  <v-layout class="text-area-dropdown-options">
    <v-textarea
      outlined
      no-resize
      v-model="optionsItems"
      :placeholder = "placeholder"
      :rules="rules"
      @change="valueChanged"
    >
    </v-textarea>
  </v-layout>
</template>

<script>
  import _ from 'lodash';

  export default {
    name: "TextAreaDropDownOptions",
    props: ['options'],
    data: function () {
      return {
        optionsItems: [],
        placeholder : this.$t('settings.client_card.possible_fields_options'),
        rules: [
          v => (this.optionsItems.length > 0) || this.$t('settings.client_card.minimum_one_option'),
          v => {
            if(!this.splitToOptions){
              return false
            }
            let data = _.uniq(this.splitToOptions).length !== this.splitToOptions.length
            return !data || this.$t('settings.client_card.duplicates_are_not_allowed');
          }
        ],
      }
    },
    methods: {
      valueChanged() {
        this.$emit("dropdownOptionsChanged", this.splitToOptions)
      }
    },
    created: function (){
      if(this.options){
          this.optionsItems = this.options.join().replace(/,/g,"\n")
      }
    },
    computed:{
      splitToOptions() {
          return (typeof this.optionsItems == "string" ?  this.optionsItems.trim().split("\n") :  null)
      }


    }
  };
</script>
<style lang="scss" scoped>
  @import "../../../assets/scss/abstract/_variables.scss";
  @import "../../../assets/scss/abstract/i18n-mixins";
  @import "../../../assets/scss/abstract/mixins";

  .text-area-dropdown-options{
    width: 100%;

    .v-textarea.v-text-field--enclosed{
      font-size: 14px;
      margin-top: 4px;
      line-height: 20px;
    }

    textarea {
      font-family: var(--font3);
      outline: none;
      width: 70%;
      height: 107px;
      border-radius: 2px;
      border: solid 1px rgba(0, 0, 0, 0.12);
      padding: 9px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.54);
    }

    @include sm-and-down {
      width: 100%;
    }
  }



</style>
